export function canShowDialogChat({ textChatEnabled = false, entered = false, hasDialogConnectedOnce = false } = {}) {
  return Boolean(textChatEnabled && entered && hasDialogConnectedOnce);
}

export function canSendDialogChat({ textChatEnabled = false, entered = false, dialogConnected = false } = {}) {
  return Boolean(textChatEnabled && entered && dialogConnected);
}

export function canShowParticipantDialogChat({
  person,
  textChatEnabled = false,
  entered = false,
  hasDialogConnectedOnce = false
} = {}) {
  return Boolean(
    canShowDialogChat({ textChatEnabled, entered, hasDialogConnectedOnce }) &&
      person &&
      !person.isMe &&
      person.presence !== "lobby"
  );
}
